import {io} from "socket.io-client";
import {baseUrl} from "../services/AxiosInstance";

export const socket = io(baseUrl, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  timeout: 12000,
  extraHeaders: {
    "ngrok-skip-browser-warning": "69420",
  },
});
